import { Input } from '../../../../shared/components/FormControls';
import Rodal from 'rodal';
import { Button } from '../../../../shared/components/Button';
import '../../../../shared/styles/Orchestrator.css';
import 'rodal/lib/rodal.css';
import { useEffect, useState } from 'react';

const TRACKER_SIZES = [4, 6, 8, 10, 12];

function TrackerModal({
  visible,
  form,
  isEditing,
  onChange,
  onCancel,
  onSave,
  onDelete,
  mode = 'light',
}) {
  const isDark = mode === 'dark';
  const [isPhone, setIsPhone] = useState(false);
  const getSizeButtonType = (size) => (
    form.size === size ? 'cinnabar' : 'black-white'
  );

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 620px)');
    const handler = () => setIsPhone(mq.matches);
    handler();
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const canSave = (form.name || '').trim().length > 0;

  return (
    <Rodal
      animation='slideUp'
      visible={visible}
      onClose={onCancel}
      className={isDark ? 'df_rodal_dark' : ''}
      customStyles={{
        border: isDark ? '2px solid var(--onyx)' : '2px solid #e4e7c5',
        backgroundColor: isDark ? 'var(--jet)' : '#f6f7eb',
        color: isDark ? 'var(--ivory)' : 'var(--jet)',
        width: isPhone ? 'calc(100% - 34px)' : 380,
        height: isPhone ? 'calc(100% - 114px)' : 340,
        marginTop: isPhone ? '80px' : '',
      }}
    >
      <div
        className={`trialment_login_form${isDark ? ' df_modal_form_dark' : ''}`}
        style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <div style={{ flex: 1, overflowY: isPhone ? 'auto' : 'visible' }}>
          <div
            className='trialment_login_form_row'
            style={{ fontWeight: 700, fontSize: 16, marginBottom: 6, textAlign: 'center' }}
          >
            {isEditing ? 'Edit Tracker' : 'Add Tracker'}
          </div>
          <div className='trialment_login_form_row'>
            <Input
              type='text'
              placeholder='Tracker Name'
              value={form.name || ''}
              onChange={(e) => onChange({ name: e.target.value })}
              style={{ width: '100%' }}
              autoFocus
            />
          </div>
          <div className='trialment_login_form_row'>
            <Input
              type='text'
              placeholder='Group (optional)'
              value={form.group || ''}
              onChange={(e) => onChange({ group: e.target.value })}
              style={{ width: '100%' }}
            />
          </div>
          <div className='trialment_login_form_row' style={{ display: 'flex', gap: 12 }}>
            <label style={{ display: 'flex', flexDirection: 'column', gap: 6, flex: 1 }}>
              <span style={{ fontSize: '13px', fontWeight: 600 }}>Size</span>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {TRACKER_SIZES.map((size) => (
                  <Button
                    key={size}
                    label={String(size)}
                    type={getSizeButtonType(size)}
                    onPress={() => onChange({ size })}
                  />
                ))}
              </div>
            </label>
            <label style={{ display: 'flex', flexDirection: 'column', gap: 6, flexShrink: 0 }}>
              <span style={{ fontSize: '13px', fontWeight: 600 }}>Color</span>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                <Input
                  type='color'
                  value={form.color || '#e94f37'}
                  onChange={(e) => onChange({ color: e.target.value })}
                />
                <Input
                  type='text'
                  value={form.color || '#e94f37'}
                  onChange={(e) => onChange({ color: e.target.value })}
                  style={{ width: '100px' }}
                  placeholder='#e94f37'
                />
              </div>
            </label>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: 8,
            marginBottom: 8,
          }}
        >
          {isEditing ? (
            <Button label='Delete' type='cinnabar' onPress={onDelete} />
          ) : (
            <span />
          )}
          <div style={{ display: 'flex', gap: 10 }}>
            <Button
              label='Cancel'
              type={isDark ? 'onyx' : 'black-white'}
              onPress={onCancel}
            />
            <Button
              label='Save'
              type='cinnabar'
              onPress={onSave}
              disabled={!canSave}
            />
          </div>
        </div>
      </div>
    </Rodal>
  );
}

export default TrackerModal;
